export default function ({ $datadog, $auth }) {
  /**
   * Returns the user's full name using the given and familly name
   * @param {{ given_name:string?, family_name: string?}} user
   */
  function getUserFullName(user) {
    return [user.given_name, user.family_name]
      .filter((part) => !!part)
      .join(' ')
  }

  if (!$auth.loggedIn) {
    console.log('[Datadog] Anonymous Mode: Cannot set the current user')
    return
  }

  $datadog.setUser({
    id: $auth.user.sub,
    name: getUserFullName($auth.user),
    email: $auth.user.email,
  })

  console.log('[Datadog] User setup')
}
